export const locales = [
  "ar-SA",
  "cs",
  "de-DE",
  "en-CA",
  "en-IN",
  "en-GB", 
  "en-US", 
  "es-ES", 
  "es-MX", 
  "fr-CA", 
  "fr-FR", 
  "id-ID", 
  "it-IT", 
  "ja-JP", 
  "ko-KR", 
  "ne-NP", 
  "nl-NL", 
  "pl-PL", 
  "pt-BR", 
  "ro-RO", 
  "ru-RU", 
  "sk", 
  "so-SO", 
  "tr-TR", 
  "uk-UA", 
  "vi-VN", 
  "zh-CN", 
  "zh-TW", 
];
